import React, { Component } from 'react';
import { TagGroup } from 'v1/components/shared';
import moment from 'moment-timezone';
import { isEmpty } from 'lodash';
import { makeFileURL } from 'lib/s3/s3Helper';
import './PinComponents.scss';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from 'v5/design-system/DropdownMenu.js';
import { Download, ExternalLink, MoreHorizontal, Trash2 } from 'lucide-react';
import { Button } from 'v5/design-system/Button.js';

export default class PinLabel extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  renderName = pin => {
    let url = pin.url
      ? pin.url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0]
      : '';
    if (pin.file) {
      return pin.file.name ? pin.file.name : pin.pin_type;
    }
    return url || 'Untitled';
  };
  getUrl = pin => {
    if (pin.file) {
      return makeFileURL(pin.file);
    }
    if (pin.url) {
      return pin.url;
    }
  };
  renderActions = pin => {
    const { type, options = {} } = this.props;
    let OPTIONS = [];

    switch (type) {
      case 'IMAGE':
        OPTIONS = [
          {
            text: 'Download',
            icon: <Download />,
            download: this.getUrl(pin)
          },
          {
            text: 'Delete Pin',
            icon: <Trash2 className="text-fg-danger" />,
            action: () => {
              this.setState({ deleting: true }, () => {
                this.props.onDeletePin(pin.id);
              });
            }
          }
        ];
        if (options.includeProfileImageButton) {
          OPTIONS.unshift({
            text: 'Set as profile picture',
            icon: (
              <img
                src="/images/icon_profile_picture.svg"
                alt="Profile Picture"
              />
            ),
            action: () => {
              this.props.onSetAsProfilePicture(pin);
            }
          });
        }
        break;
      case 'FILE':
      case 'VIDEO':
        OPTIONS = [
          {
            text: 'Download',
            icon: <Download />,
            download: this.getUrl(pin)
          },
          {
            text: 'Delete Pin',
            icon: <Trash2 className="text-fg-danger" />,
            action: () => {
              this.setState({ deleting: true }, () => {
                this.props.onDeletePin(pin.id);
              });
            }
          }
        ];
        break;
      case 'WEB_LINK':
      case 'PROVIDER_FILE':
      default:
        OPTIONS = [
          {
            text: 'Go to link',
            icon: <ExternalLink />,
            href: this.getUrl(pin)
          },
          {
            text: 'Delete Pin',
            icon: <Trash2 className="text-fg-danger" />,
            action: () => {
              this.setState({ deleting: true }, () => {
                this.props.onDeletePin(pin.id);
              });
            }
          }
        ];
        break;
    }

    return (
      <div className="PinLabel-actions tailwind-root">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button size="sm" variant="invert" layout="icon">
              <MoreHorizontal />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" onClick={e => e.stopPropagation()}>
            {OPTIONS.map((link, index) => {
              if (link.href || link.download) {
                return (
                  <DropdownMenuItem size="lg" key={link.text} asChild>
                    <a
                      href={link.href || link.download}
                      {...(link.download ? { download: true } : {})}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {link.icon}
                      {link.text}
                    </a>
                  </DropdownMenuItem>
                );
              }
              return (
                <DropdownMenuItem
                  size="lg"
                  key={link.text}
                  onSelect={link.action}
                >
                  {link.icon}
                  {link.text}
                </DropdownMenuItem>
              );
            })}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
  };
  renderMeta = (user, pin) => {
    if (user) {
      return (
        <span className="PinLabel-meta">
          {user.first_name} pinned {moment(pin.created_at).fromNow()}
        </span>
      );
    }
  };
  renderTags = tags => {
    return (
      <div className="PinLabel-tags">
        <TagGroup tags={tags} tagType="tag" limit={2} darkMode />
      </div>
    );
  };
  render() {
    const { pin /*user*/ } = this.props;
    return (
      <div className="PinLabel">
        {!isEmpty(pin.tags) && this.renderTags(pin.tags)}
        <div className="Pinlabel-details">
          <div className="PinLabel-details-owner">
            {this.state.deleting ? (
              'Deleting...'
            ) : (
              <a
                href={this.getUrl(pin)}
                className="Pinlabel-name"
                target="_blank"
                rel="noopener noreferrer"
              >
                {this.renderName(pin)}
              </a>
            )}
          </div>
          <div className="Pinlabel-actions">{this.renderActions(pin)}</div>
        </div>
      </div>
    );
  }
}
